import { Component, Input, OnChanges, SimpleChanges } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { MatIconModule } from '@angular/material/icon';
import { Router } from '@angular/router';

@Component({
    selector: 'app-application-stepper',
    standalone: true,
    imports: [
        CommonModule,
        TranslateModule,
        MatProgressBarModule,
        MatIconModule,
    ],
    templateUrl: './application-stepper.component.html',
    styleUrl: './application-stepper.component.scss',
})
export class ApplicationStepperComponent implements OnChanges {
    steps = [
        {
            label: 'APPLICATION_STEPPER.STEP_1',
            title: 'APPLICATION_STEPPER.TITLE_1',
            description: 'APPLICATION_STEPPER.SHORT_BRIEF_1',
            threshold: 20,
            linePosition: '13.3%',
        },
        {
            label: 'APPLICATION_STEPPER.STEP_2',
            title: 'APPLICATION_STEPPER.TITLE_2',
            description: 'APPLICATION_STEPPER.SHORT_BRIEF_2',
            threshold: 35,
            linePosition: '38.3%',
        },
        {
            label: 'APPLICATION_STEPPER.STEP_3',
            title: 'APPLICATION_STEPPER.TITLE_3',
            description: 'APPLICATION_STEPPER.SHORT_BRIEF_3',
            threshold: 65,
            linePosition: '63.3%',
        },
        {
            label: 'APPLICATION_STEPPER.STEP_4',
            title: 'APPLICATION_STEPPER.TITLE_4',
            description: 'APPLICATION_STEPPER.SHORT_BRIEF_4',
            threshold: 100,
        },
    ];

    @Input() value: any;
    selectedLanguage: string;
    val: number = 0;
    @Input() productName: string;
    financialProductsTitle: boolean;

    constructor(private translate: TranslateService, private router: Router) {
        this.selectedLanguage = localStorage.getItem('language');
        this.translate.onLangChange.subscribe((event) => {
            this.selectedLanguage = event.lang;
        });
        this.financialProductsTitle = this.router.url.includes('/non-eligible')
    }

    ngOnChanges(changes: SimpleChanges) {
        if (changes.value) {
            this.val = changes.value.currentValue;
        }
    }
}
